import { MenuItemCategoryLink } from './MenuItemCategoryLink';
import { MenuItemCategoryLinkMultiple } from './MenuItemCategoryLinkMultiple';
import { MenuItemExternalLink } from './MenuItemExternalLink';
import { MenuItemNewsletter } from './MenuItemNewsletter';
import { MenuItemPageLink } from './MenuItemPageLink';
import { MenuItemPostLink } from './MenuItemPostLink';
import { MenuItemSocialLinks } from './MenuItemSocialLinks';
import { MenuItemType } from './MenuItemType';


export { MenuItemCategoryLinkMultiple } from './MenuItemCategoryLinkMultiple';
export { MenuItemCategoryLink } from './MenuItemCategoryLink';
export { MenuItemExternalLink } from './MenuItemExternalLink';
export { MenuItemPageLink } from './MenuItemPageLink';
export { MenuItemPostLink } from './MenuItemPostLink';
export { MenuItemSocialLinks } from './MenuItemSocialLinks';
export { MenuItemNewsletter } from './MenuItemNewsletter';

export type MenuItem =
  | MenuItemCategoryLinkMultiple
  | MenuItemCategoryLink
  | MenuItemExternalLink
  | MenuItemPageLink
  | MenuItemPostLink
  | MenuItemSocialLinks
  | MenuItemNewsletter;

export namespace MenuItem {
  export const getType = (model: MenuItem): MenuItemType => model.type;
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/item/index.ts